// ============================================================
// Fee Installments API
// ============================================================

import client from './axios';

export const feeInstallmentsApi = {
  /**
   * Get all installments for a specific fee structure item
   */
  getInstallments: async (feeStructureItemId) => {
    const response = await client.get(`/fee-installments/${feeStructureItemId}/installments`);
    return response.data;
  },

  /**
   * Create installments for a fee structure item (takes array of installment objects)
   */
  createInstallments: async (feeStructureItemId, payloadArray) => {
    const response = await client.post(
      `/fee-installments/${feeStructureItemId}/installments`,
      payloadArray
    );
    return response.data;
  },

  /**
   * Update a specific installment
   */
  updateInstallment: async (installmentId, payload) => {
    const response = await client.put(`/fee-installments/${installmentId}`, payload);
    return response.data;
  },

  /**
   * Delete a specific installment
   */
  deleteInstallment: async (installmentId) => {
    const response = await client.delete(`/fee-installments/${installmentId}`);
    return response.data;
  },
};
